import { captureException } from '@sentry/nextjs';

type HotjarCommand = 'event';

interface WindowWithHotjar extends Window {
  hj?: {
    (method: HotjarCommand, ...data: unknown[]): void;
    (method: string, ...data: unknown[]): void;
  };
}

declare const window: WindowWithHotjar;

const executeHotjarCommand = (command: HotjarCommand, ...args: unknown[]): void => {
  if (typeof window !== 'undefined' && window.hj) {
    window.hj(command, ...args);
  }
};

// eslint-disable-next-line import/prefer-default-export
export const event = (actionName: string): boolean => {
  try {
    executeHotjarCommand('event', actionName);
    return true;
  } catch (error) {
    captureException(error);
    return false;
  }
};
